var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__header"},[(_vm.text)?_c((_vm.event ? 'button' : 'h3'),{tag:"component",staticClass:"card__title",domProps:{"textContent":_vm._s(_vm.text)},on:_vm._d({},[_vm.event,_vm.onClick])}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }